<template>
  <div>
    <!-- <div class="bannerW">
      <el-image
        :src="require('@/assets/img/career.jpg')"
        fit="cover"
        class="banner"
      ></el-image>
      <div class="titleBox">
        <h2>融合发展</h2>
        <p>INTEGRATED DEVELOPMENT</p>
      </div>
    </div> -->
    <Banner :classType="6" />

    <Menu />
    <div class="pageTitle wow animate__slideInUp">
      <h2>{{ titleObj[type].name }}</h2>
      <p>{{ titleObj[type].enName }}</p>
    </div>

    <div class="wrap careerBox wow animate__slideInUp">
      <div v-show="newsType==11">
        <NewsList  :newsList="newsList" />
        <div class="pageBox" v-if="showPage">
        <Pagination @pageChange="getNewsList" :PagingInfo="PagingInfo" />
        </div>
      </div>
      
      <div v-show="newsType==12">
        <NewsList3 :newsList="newsList2"  />
        <div class="pageBox" v-if="showPage2">
        <Pagination @pageChange="getNewsList2" :PagingInfo="PagingInfo2" />
        </div>
      </div>
     
      
    
    </div>
  </div>
</template>

<script>
import NewsList from "@/views/components/NewsList";
import NewsList3 from "@/views/components/NewsList3";
import Menu from "./Menu.vue";
import { WOW } from "wowjs";
import Pagination from "@/views/components/Pagenation";
import Banner from "@/views/components/Banner";

export default {
  data() {
    return {
      type: this.$route.query.type || "advanced",
      titleObj: {
        advanced: { name: "先进典型", enName: "ADVANCED MODELS" },
        staff: { name: "员工风采", enName: "STAFF PRESENCE" },
      },
      newsList: [],
      newsList2: [],
      PagingInfo: {},
      PagingInfo2: {},
      newsType: 11,
      pageCur: 1,
      pageCur2:1,
      showPage: false,
      showPage2:false
    };
  },
  components: {
    NewsList,
    NewsList3,
    Menu,
    Pagination,
    Banner,
  },
  methods: {
    getNewsList(page, type) {
      this.$api
        .newsList({
          Type: this.newsType,
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
         
          const { NewsItems, PagingInfo } = res.Value;
          this.newsList = NewsItems;
          this.PagingInfo = PagingInfo;
          if (PagingInfo.TotalPages >1) {
            this.showPage = true
          }
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },

    getNewsList2(page, type) {
      this.$api
        .newsList({
          Type: this.newsType,
          CurrentPage: page,
          ItemsPerPage:6,
        })
        .then((res) => {
         
          const { NewsItems, PagingInfo } = res.Value;
          this.newsList2 = NewsItems;
          console.log(res.Value,"---")
          this.PagingInfo2 = PagingInfo;
          if (PagingInfo.TotalPages >1) {
            this.showPage2 = true
          }
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
    changeNewsType() {
      switch (this.type) {
        case "advanced":
          this.newsType = 11;
          break;
        case "staff":
          this.newsType = 12;
          break;
      }
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.type = this.$route.params.type;
        this.changeNewsType();
        this.getNewsList(1);
        this.getNewsList2(1);
      }
    );
  },
  beforeRouteEnter(to, from,next) {
    let fromURL = from.name
    next((vm)=>{
      if(fromURL == 'newsContent')
      vm.pageCur =sessionStorage.getItem('currentPage')
    })
  },
  mounted() {
    this.type = this.$route.params.type;
    this.changeNewsType();
    this.getNewsList(this.pageCur, "first");
    this.getNewsList2(this.pageCur2, "first");
    /* new WOW({
      boxClass: "wow",
      animateClass: "animate__animated",
      live: false,
    }).init(); */
  },
};
</script>

<style lang="scss">
.careerBox {
  padding: 50px 0 20px;
}
</style>